module.exports = __webpack_public_path__ + "static/image2_fr-c02c452769a922254bc17721f11e0893.png";